const normalize = (value) => String(value || '').trim()

export const normalizeInquiryEmail = (value) => normalize(value).toLowerCase()

const getFamilyId = (family = {}) => normalize(
    family?.familyId || family?.FamilyID || family?.id || family?._id
)

const createFamilySummary = (family) => ({
    familyId: getFamilyId(family),
    familyName: normalize(family?.familyName || family?.FamilyName) || 'Unknown family',
    familyStatus: normalize(family?.familyStatus || family?.FamilyStatus),
    school: normalize(family?.school || family?.School).toUpperCase(),
})

export const buildDuplicateInquiryInfoByFamilyId = (families = []) => {
    const familiesByEmail = new Map()

    ;(Array.isArray(families) ? families : []).forEach((family) => {
        const familyId = getFamilyId(family)
        const email = normalizeInquiryEmail(family?.primaryEmail)
        if (!familyId || !email) return

        const emailFamilies = familiesByEmail.get(email) || new Map()
        emailFamilies.set(familyId, createFamilySummary(family))
        familiesByEmail.set(email, emailFamilies)
    })

    const duplicateInfoByFamilyId = {}
    familiesByEmail.forEach((familiesWithEmail, email) => {
        const familyList = Array.from(familiesWithEmail.values())
        if (familyList.length < 2) return

        familyList.forEach((family) => {
            duplicateInfoByFamilyId[family.familyId] = {
                email,
                matches: familyList.filter(
                    (possibleMatch) => possibleMatch.familyId !== family.familyId
                ),
            }
        })
    })

    return duplicateInfoByFamilyId
}

export const shouldShowDuplicateInquiryWarning = (card = {}) => {
    const description = normalize(card?.todoDescription).toLowerCase()
    const list = normalize(card?.whichList).toLowerCase()

    return list !== 'teacher'
        && list !== 'leaving'
        && list !== 'orange'
        && list !== 'blue'
        && description !== 'reassign'
        && description !== 'old student'
}

export const formatDuplicateInquiryWarning = (duplicateInfo = {}) => {
    const matches = Array.isArray(duplicateInfo?.matches) ? duplicateInfo.matches : []
    const matchingFamilies = matches.map((family) => {
        const details = [family.familyStatus, family.school].filter(Boolean).join(' · ')
        return details ? `${family.familyName} (${details})` : family.familyName
    })

    return matchingFamilies.length > 0
        ? `Duplicate email: ${duplicateInfo.email}. Also matches ${matchingFamilies.join(', ')}.`
        : `Duplicate email: ${duplicateInfo.email}.`
}
